module.exports = __webpack_public_path__ + "img/Avatar-73.df45cec0.svg";